<template>
  <div id="app">
    <ul id="menu">
      <li data-menuanchor="home" class="active"><a href="#home">Home</a></li>
      <li data-menuanchor="about"><a href="#about">About</a></li>
      <li data-menuanchor="portfolio"><a href="#portfolio">Portfolio</a></li>
      <li data-menuanchor="contact"><a href="#contact">Contact</a></li>
    </ul>
    <full-page ref="fullpage" :options="options" id="fullpage">

      <FirstPage></FirstPage>
      <AboutPage></AboutPage>
      <PortfolioPage></PortfolioPage>
      <ContactPage></ContactPage>

    </full-page>
  </div>

</template>

<script>
import 'fullpage.js/dist/fullpage.css'
import FirstPage from '@/components/FirstPage.vue'
import AboutPage from '@/components/AboutPage.vue'
import PortfolioPage from '@/components/PortfolioPage.vue'
import ContactPage from '@/components/ContactPage.vue'

export default {
  components: {
    FirstPage,
    AboutPage,
    PortfolioPage,
    ContactPage
  },
  data() {
    return {
      name: 'app',
      options: {
        menu: '#menu',
        anchors: ['home', 'about', 'portfolio', 'contact'],
        // sectionsColor: ['#f2f2f/2', '#4BBFC3', '#7BAABE', 'whitesmoke'],
        navigation: true,
        navigationPosition: 'right'
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 30px;
}

a {
  color: green;
}

#headshot {
  width: 400px;
  height: 400px;
}
</style>
